<template>    
    <div class="hero__outer">
        <div class="hero hero__inner" id="hero">        
            <div class="hero-container">
                <!-- CONTENT -->
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12 col-xxl-7 col-lg-6 px-0 position-relative hero-man">
                            <img src="@/assets/imgs/hero-product.png" class="img-fluid hero-product" />
                            <img src="@/assets/imgs/hero-shape.png" class="img-fluid hero-shape d-none d-lg-block" />
                            <img src="@/assets/imgs/hero-shape-mobile.svg" class="img-fluid hero-shape-mobile d-block d-lg-none"  v-if="$store.state.promoStatus == 'live'"/>
                            <img src="@/assets/imgs/hero-closed-shape-mobile.svg" class="img-fluid hero-shape-mobile d-block d-lg-none"  v-if="$store.state.promoStatus == 'after'"/>
                        </div>
                        <div class="col-12 col-xxl-5 col-lg-6 d-flex align-items-center" style="z-index: 2;">
                            <div class="row pt-5">
                                <div class="col-12 py-lg-5 text-center text-lg-start" v-if="$store.state.promoStatus == 'live'">
                                    <img src="@/assets/imgs/hero-heading.png" class="img-fluid d-none d-lg-block" width="500"/>
                                </div>
                                <div class="col-12 py-lg-5 text-center text-lg-start" v-if="$store.state.promoStatus == 'after'">
                                    <img src="@/assets/imgs/hero-closed.png" class="img-fluid d-none d-lg-block" width="500"/>
                                </div>
                                <div class="col-12 col-md-10 offset-md-1 offset-lg-0 col-lg-10 col-xxl-10" v-if="$store.state.promoStatus == 'live'">
                                    <div class="game-rules pt-md-0 pt-5 pl-4">
                                        <ul>
                                            <li class="position-relative">
                                                <img src="@/assets/imgs/icon-step-1.png" class="img-fluid position-absolute step" style="top: 15px;"/>
                                                Vásárolj bármilyen <span class="text-gold">promóciós csomagolású Soproni Klasszikust!</span>
                                            </li>
                                            <li class="position-relative">
                                                <img src="@/assets/imgs/icon-step-2.png" class="img-fluid position-absolute step" style="top: 25%;"/>
                                                Lesd meg a nyitófület vagy kupakot és <span class="text-gold">töltsd fel a kódot</span> a promóciós weboldalra <span class="text-gold">2024.04.15 és 2024.07.15 között</span>!
                                            </li>
                                            <li class="position-relative">
                                                <img src="@/assets/imgs/icon-step-3.png" class="img-fluid position-absolute step" style="top: 0px;"/>
                                                Fotózd le és őrizd meg a <span class="text-gold">nyitófület</span> vagy <span class="text-gold">kupakot</span>!
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-12 col-md-10 offset-md-1 offset-lg-0 col-lg-10 col-xxl-8" v-if="$store.state.promoStatus == 'after'">
                                    <p class="text-white fs-24">Köszönjük, hogy velünk játszottál!<br>A nyertesek listájához görgess lejjebb!</p>
                                </div>
                                <div class="col-12 text-lg-start text-center">
                                    <div class="text-left text-dark mt-4">
                                        <button v-if="$store.state.promoStatus == 'live'"
                                            class="btn btn-secondary mb-3 order-md-2 me-md-2 md-btn"
                                            v-scroll-to="{el:!$store.state.user ? '#regisztracio' : '#palyazat',  offset: -80}"
                                            @click="setGtm('Játszom')"
                                        >
                                            Játszom!
                                            <img src="@/assets/imgs/arrow-circle.svg" class="img-fluid ms-2 mb-1">
                                        </button>
                                        <a class="btn btn-border me-0 ms-lg-2 order-md-1 mb-3 md-btn" :href="$store.state.file_url" target="_blank" v-if="$store.state.promoStatus == 'live'">
                                            Játékszabályzat
                                            <img src="@/assets/imgs/arrow-circle.svg" class="img-fluid ms-2 mb-1">
                                        </a>   
                                        <a class="btn btn-third me-0 ms-lg-2 order-md-1 mb-3 md-btn" :href="$store.state.file_url" target="_blank" v-if="$store.state.promoStatus == 'after'">
                                            Játékszabályzat
                                            <img src="@/assets/imgs/arrow-circle.svg" class="img-fluid ms-2 mb-1">
                                        </a> 
                                    </div>           
                                </div>         
                            </div>
                        </div>
                    </div>   
                </div>     
            </div>  
            <div class="py-3 bg-dark-red text-center text-white">                               
                <p class="mb-0 font-primary fs-22 px-3" style="line-height:25px;" v-if="$store.state.promoStatus == 'live'">Óránkénti nyeremény: naponta összesen 15 db, 07:00:00 és 21:59:59 között.<br/>A nyitófelület vagy kupakot a nyereményjáték lezárulta után további 2 hónapig (2024.szeptember 15-ig.),<br>illetve a nyertesség esetén a nyeremények átadásáig meg kell őrizni.</p>
                <p class="mb-0 font-primary fs-22 px-3 py-5" style="line-height:25px;" v-if="$store.state.promoStatus == 'after'">A nyitófelület vagy kupakot a nyereményjáték lezárulta után további 2 hónapig (2024.szeptember 15-ig.),illetve a nyertesség esetén a nyeremények átadásáig meg kell őrizni.</p>
            </div>              
        </div>
    </div>            
</template>

<script>

//import Ribbon from '@/components/Ribbon.vue'

export default {
    components:{
        //Ribbon
    },
    methods: {      
        setGtm(){
            window.dataLayer.push('event', 'conversion', {
                'allow_custom_scripts': true,
                'send_to': 'DC-9373807/soproni/2024_000+standard'
            });
            
            /*this.GTtrackGA4({
                'event' : 'event',
                'category': 'jatekleiras',
                'action': 'gomb_kattintas',
                'label': btnName,                
                'clicked_text':btnName,
                'action_type': 'gomb_kattintas'
            })*/
        }
    }
}
</script>